import axios from 'axios'

export const BASE_API_URL = '/api/v1/'

const instance = axios.create({
  baseURL: BASE_API_URL,
})

export default instance
